<i #formTooltip [matTooltipClass]="'formIconTooltip'" *ngIf="!form.valid && clicked" #warning
   matTooltip="{{errorInformation.slice(0, errorInformation.length - 2)}}" matTooltipPosition="right"
   class="material-icons warning">
  warning
</i>
